export default {
    // General
    loading: 'Laden',
    home: 'Startseite',
    back: 'Zurück',
    confirm: 'Bestätigen',
    cancel: 'Abbrechen',
    close: 'Schließen',
    save: 'Speichern',
    delete: 'Löschen',
    edit: 'Bearbeiten',
    add: 'Hinzufügen',
    yes: 'Ja',
    no: 'Nein',
    or: 'oder',
    and: 'und',
    required: 'Pflichtfeld',
    optional: 'Optional',

    // Store status
    storeOpen: 'Geöffnet',
    storeClosed: 'Geschlossen',
    storeOpenSoon: 'Öffnet bald',

    // Navigation
    categories: 'Kategorien',
    siteMap: 'Seitenübersicht',
    cart: 'Warenkorb',
    myAccount: 'Mein Konto',

    // Auth
    login: 'Anmelden',
    register: 'Registrieren',
    logout: 'Abmelden',
    forgotPassword: 'Passwort vergessen?',
    rememberMe: 'Angemeldet bleiben',
    alreadyHaveAccount: 'Bereits ein Konto?',
    noAccount: 'Noch kein Konto?',
    signIn: 'Einloggen',

    // Form fields
    email: 'E-Mail',
    password: 'Passwort',
    confirmPassword: 'Passwort bestätigen',
    firstName: 'Vorname',
    lastName: 'Nachname',
    phone: 'Telefon',
    address: 'Adresse',
    city: 'Stadt',
    postalCode: 'Postleitzahl',
    country: 'Land',

    // Password rules
    passwordRules: 'Das Passwort muss mindestens 10 Zeichen, einen Großbuchstaben, einen Kleinbuchstaben, eine Zahl und ein Sonderzeichen enthalten',
    confirmPasswordMessage: 'Bitte bestätigen Sie Ihr Passwort',
    passwordValid: 'Passwort gültig',
    passwordInvalid: 'Passwort ungültig',
    passwordMismatch: 'Passwörter stimmen nicht überein',
    passwordMissingLength: 'mindestens {min} Zeichen',
    passwordMissingUppercase: 'ein Großbuchstabe',
    passwordMissingLowercase: 'ein Kleinbuchstabe',
    passwordMissingNumber: 'eine Zahl',
    passwordMissingSpecial: 'ein Sonderzeichen',
    optionFreeRemaining: 'Sie können noch {count} kostenlose Option auswählen!',
    optionSelectAtLeastOne: 'Sie müssen mindestens eine Option auswählen!',
    optionSelectionRequired: 'Eine Auswahl ist für diese Option erforderlich!',
    mustAcceptTerms: 'Sie müssen die Nutzungsbedingungen akzeptieren.',
    registerFormAlreadySubmitted: 'Das Registrierungsformular wurde gesendet, bitte warten!',
    newPassword: 'Neues Passwort',
    oldPassword: 'Altes Passwort',
    verifyingInfo: 'Wir überprüfen Ihre Informationen',
    contactUs: 'Bitte kontaktieren Sie uns!',
    invalidInfo: 'Ihre Informationen sind ungültig',
    deleteAccountRequest: 'Kontolöschungsantrag',
    deleteAccountConfirmText: 'Wenn Sie Ihr Konto löschen möchten, geben Sie bitte Ihr Passwort ein',

    // Terms
    acceptTerms: 'Nutzungsbedingungen akzeptieren',
    privacyPolicy: 'Datenschutzrichtlinie',
    termsOfUse: 'Nutzungsbedingungen',

    // Product
    select: 'Auswählen',
    addToCart: 'Hinzufügen',
    options: 'Optionen',
    description: 'Beschreibung',
    noDescription: 'Keine Beschreibung verfügbar',
    nameUnavailable: 'Name nicht verfügbar',
    someOptionsPaid: 'einige Optionen sind kostenpflichtig',

    // Cart / Order
    cartTitle: 'Warenkorb',
    cartSummary: 'Warenkorbübersicht',
    orderCommand: 'Bestellen',
    validateOrder: 'Bestellung bestätigen',
    total: 'Gesamt',
    subtotal: 'Zwischensumme',
    deliveryFees: 'Liefergebühren',
    free: 'kostenlos',
    paid: 'kostenpflichtig',
    orderPaid: 'Bezahlt',
    orderUnpaid: 'Unbezahlt',
    maximum: 'Maximum',
    quantity: 'Menge',

    // Payment
    payByCard: 'Mit Karte bezahlen',
    payOnSite: 'Vor Ort bezahlen',
    paymentSuccess: 'Zahlung erfolgreich',
    paymentError: 'Zahlungsfehler',

    // Delivery
    delivery: 'Lieferung',
    pickup: 'Abholung',
    tableReservation: 'Tischreservierung',
    deliveryZones: 'Lieferzonen',
    deliveryFee: 'Liefergebühr',
    minimumOrder: 'Mindestbestellung',
    freeFrom: 'Kostenlose Lieferung ab',

    // Dashboard
    dashboard: 'Dashboard',
    orderHistory: 'Bestellverlauf',
    addressBook: 'Adressbuch',
    setDefault: 'Standard',
    requestAccessCode: 'Fordern Sie einen Code an, um auf Ihr Konto zuzugreifen',
    code: 'Code',
    myInfo: 'Meine Daten',
    myAddresses: 'Meine Adressen',
    addAddress: 'Adresse hinzufügen',
    editAddress: 'Adresse bearbeiten',
    deleteAddress: 'Adresse löschen',
    deleteAccount: 'Konto löschen',
    modifyPassword: 'Passwort ändern',
    cancelAccountDeletion: 'Kontolöschung abbrechen',
    loginToOrder: 'Sie müssen eingeloggt sein, um zu bestellen',
    send: 'Senden',
    missingFields: 'Fehlende oder ungültige Felder',
    forgotPasswordDescription: 'Geben Sie Ihre E-Mail-Adresse ein, um Ihr Passwort zurückzusetzen',
    enterEmail: 'Geben Sie Ihre E-Mail-Adresse ein',
    forgotPasswordTitle: 'Passwort vergessen',
    passwordResetTitle: 'Passwort zurücksetzen',
    disconnectSuccess: 'Erfolgreich abgemeldet',
    captchaRequired: 'Bitte füllen Sie das Captcha aus',
    captchaLoading: 'Captcha wird geladen...',
    captchaError: 'Captcha-Fehler. Bitte versuchen Sie es erneut.',
    retry: 'Erneut versuchen',
    productAddedSuccess: 'Ihr Produkt wurde erfolgreich hinzugefügt!',
    productAssociatedSuggestion: 'Kunden empfehlen diese Produkte passend zu Ihrer Auswahl.',
    productAssociatedTitle: 'Zugehörige(s) Produkt(e)',
    removeProductQuestion: 'Möchten Sie dieses Produkt aus dem Warenkorb entfernen?',
    waitBeforeRetry: 'Bitte warten Sie, bevor Sie erneut klicken',
    fillRequiredFields: 'Bitte füllen Sie alle Pflichtfelder aus',
    otpInvalid: 'Bitte geben Sie einen gültigen OTP-Code ein',
    otpSendError: 'Fehler beim Senden des OTP-Codes',
    infoUnchanged: 'Informationen haben sich nicht geändert',
    selectAddressToModify: 'Bitte wählen Sie eine Adresse zum Ändern aus',
    orderPlacedSuccess: 'Bestellung erfolgreich aufgegeben!',
    paymentSuccessMessage: 'Herzlichen Glückwunsch, Ihre Zahlung war erfolgreich!',
    orderTransmittedRestaurant: 'Ihre Bestellung wurde an das Restaurant übermittelt',
    orderNumberLabel: 'Bestellnummer:',
    pickupOrderMessage: 'Sie können Ihre Bestellung abholen um:',
    wishGoodDayMeal: 'Wir wünschen Ihnen einen guten Tag und eine angenehme Mahlzeit',
    wishGoodAfternoonMeal: 'Wir wünschen Ihnen einen schönen Nachmittag und eine angenehme Mahlzeit',
    wishGoodEveningMeal: 'Wir wünschen Ihnen einen schönen Abend und eine angenehme Mahlzeit',
    addressNotFound: 'Adresse nicht gefunden',
    accountDeletionTitle: 'Kontolöschung',
    accountDeletionCancelError: 'Fehler beim Stornieren der Kontolöschung',
    personalInfoTitle: 'Persönliche Informationen',
    selectAddressTitle: 'Adresse auswählen',
    selectedAddressNotFound: 'Die ausgewählte Adresse wurde nicht gefunden',
    todayOrders: 'Heutige Bestellungen',
    previousOrders: 'Frühere Bestellungen',
    order: 'Bestellung',
    pickupTime: 'Abholzeit',
    notConfirmed: 'Nicht bestätigt',
    cancelled: 'Storniert',
    company: 'Firma',
    addressComplement: 'Adresszusatz',
    region: 'Region',
    selectRegion: 'Region auswählen',
    selectCity: 'Stadt auswählen',
    address1: 'Adresse 1',
    // refactored — address form'a özel key'ler.
    addressFormZoneLabel: 'Region',
    addressFormCityLabel: 'Stadt',
    addressFormStreetLabel: 'Straße',
    addressFormSelectZone: 'Region auswählen',
    addressFormSelectCity: 'Stadt auswählen',
    addressSearchPlaceholder: 'Adresse suchen (Straße, Gebäude…)',
    addressMapHint: 'Klicken Sie auf die Karte oder ziehen Sie den Marker, um den Punkt zu wählen.',
    addressMapPicked: 'Ausgewählter Punkt',
    defaultAddressQuestion: 'Standardadresse',
    mandatory: 'Pflichtfeld',
    noOrdersYet: 'Sie haben noch keine Bestellungen',
    noAddressesYet: 'Sie haben noch keine gespeicherten Adressen',
    cartEmpty: 'Warenkorb ist leer',
    storeClosedLong: 'Das Geschäft ist geschlossen',

    // Order validation page
    fullName: 'Vor- und Nachname',
    orderOptions: 'Bestelloptionen',
    pickupMethod: 'Abholmethode',
    withdrawTitle: 'Abholung',
    paymentMethod: 'Zahlungsmethode',
    asSoonAsPossible: 'So bald wie möglich',
    todayLabel: 'Heute',
    existingAddress: 'Vorhandene Adresse',
    newAddress: 'Neue Adresse',
    addressAddedSuccess: 'Ihre neue Adresse wurde erfolgreich hinzugefügt.',
    selectDeliveryAddress: 'Bitte wählen Sie eine Lieferadresse aus.',
    priceDoesntMeetDelivery: 'Der Preis erfüllt die Lieferbedingungen nicht',
    restaurantDoesntAcceptPickupDelivery: 'Das Restaurant akzeptiert weder Abholung noch Lieferung',
    storeCannotTakeOrderNow: 'Das Restaurant kann Ihre Bestellung derzeit nicht entgegennehmen. Bitte versuchen Sie es später erneut',
    cardMinimumAmount: 'Um per Karte zu bestellen, muss der Gesamtbetrag {amount} oder mehr betragen.',
    hourLabel: 'Stunde',
    minuteLabel: 'Minute',
    addressPlaceholder: 'Adresse',
    emptyBasketProducts: 'Keine Produkte im Warenkorb',
    taxIncluded: 'MwSt. ({rate}%) inklusive',
    shippingTaxIncluded: 'MwSt. der Lieferkosten ({rate}%) inklusive',
    withShippingFees: 'mit Lieferkosten',
    addCommentPlaceholder: 'Sie können einen Kommentar hinzufügen',
    demoCannotOrder: 'Diese Website ist eine Demo, Sie können nicht bestellen',
    demoCannotPassOrder: 'Sie können nicht bestellen, diese Website ist eine Demo',
    validateInformationButton: 'Informationen bestätigen',
    termsValidationIntro: 'Mit der Bestätigung dieser Bestellung erklären Sie, dass Sie unsere',
    termsValidationMiddle: 'sowie unsere',
    termsValidationEnd: 'gelesen und akzeptiert haben. Wir empfehlen Ihnen, diese vor dem Kauf sorgfältig zu lesen',

    // Store status banner
    storeOpensAt: 'Öffnet um {time}',
    storeClosedOpensOn: 'Geschlossen, öffnet {day} um {time}',
    storeOrderOpenOpensAt: 'Das Bestellsystem ist aktiv, Sie können jetzt Ihre Bestellung aufgeben und ab {time} Uhr abholen.',
    storeOpenOrderClosed: 'Geschäft geöffnet - Bestellung geschlossen',
    dayFullSunday: 'Sonntag',
    dayFullMonday: 'Montag',
    dayFullTuesday: 'Dienstag',
    dayFullWednesday: 'Mittwoch',
    dayFullThursday: 'Donnerstag',
    dayFullFriday: 'Freitag',
    dayFullSaturday: 'Samstag',

    // Order status
    orderPending: 'Ausstehend',
    orderPreparation: 'In Vorbereitung',
    orderReady: 'Bereit',
    orderDelivered: 'Geliefert',
    orderCancelled: 'Storniert',

    // Footer
    openingHours: 'Öffnungszeiten',
    pickupService: 'Abholzeiten',
    deliveryService: 'Lieferzeiten',
    allRightsReserved: 'Alle Rechte vorbehalten',
    dayShortMon: 'Mo',
    dayShortTue: 'Di',
    dayShortWed: 'Mi',
    dayShortThu: 'Do',
    dayShortFri: 'Fr',
    dayShortSat: 'Sa',
    dayShortSun: 'So',

    // Errors
    error: 'Fehler',
    attention: 'Achtung',
    networkError: 'Netzwerkfehler',
    unauthorized: 'Nicht autorisiert',

    // Validation errors (backend keys)
    phone_missing: 'Telefonnummer fehlt',
    phone_invalid: 'Telefonnummer ist ungültig',
    lastname_missing: 'Nachname fehlt',
    lastname_invalid: 'Nachname ist ungültig',
    firstname_missing: 'Vorname fehlt',
    firstname_invalid: 'Vorname ist ungültig',
    password_missing: 'Passwort fehlt',
    password_rules_violated: 'Passwort entspricht nicht den Regeln',
    password_confirm_missing: 'Passwortbestätigung fehlt',
    password_confirm_rules_violated: 'Passwortbestätigung entspricht nicht den Regeln',
    password_mismatch: 'Passwörter stimmen nicht überein',
    store_name_missing: 'Shop-Name fehlt',
    store_name_invalid: 'Shop-Name ist ungültig',
    language_missing: 'Sprache fehlt',
    language_invalid: 'Sprache ist ungültig',
    customer_missing: 'Kundendaten fehlen',
    customer_invalid: 'Kundendaten sind ungültig',
    store_missing: 'Shop-Informationen fehlen',
    store_invalid: 'Shop-Informationen sind ungültig',
    remember_me_invalid: 'Option "Angemeldet bleiben" ist ungültig',
    email_missing: 'E-Mail-Adresse fehlt',
    email_invalid: 'E-Mail-Adresse ist ungültig',
    email_domain_invalid: 'E-Mail-Domain ist ungültig',
    address_fields_missing: 'Adressfelder fehlen',
    zone_missing: 'Zone fehlt',
    city_missing: 'Stadt fehlt',
    city_invalid: 'Stadt ist ungültig',
    city_too_short: 'Stadt ist zu kurz',
    city_too_long: 'Stadt ist zu lang',
    supaddress_missing: 'Adresszusatz fehlt',
    supaddress_too_short: 'Adresszusatz ist zu kurz',
    supaddress_too_long: 'Adresszusatz ist zu lang',
    supaddress_invalid: 'Adresszusatz ist ungültig',
    address_missing: 'Adresse fehlt',
    address_too_short: 'Adresse ist zu kurz',
    address_too_long: 'Adresse ist zu lang',
    address_invalid: 'Adresse ist ungültig',
    company_name_too_short: 'Firmenname ist zu kurz',
    company_name_too_long: 'Firmenname ist zu lang',
    company_name_invalid: 'Firmenname ist ungültig',
    address_id_missing: 'Adress-ID fehlt',
    address_id_invalid: 'Adress-ID ist ungültig',

    // Backend messages (snake_case keys)
    invalid_data: 'Daten sind ungültig',
    terms_not_accepted: 'Sie müssen die Nutzungsbedingungen akzeptieren',
    generic_error: 'Ein Fehler ist aufgetreten! Wenn das Problem weiterhin besteht, wenden Sie sich bitte an das Geschäft.',
    session_expired: 'Ihre Sitzung ist abgelaufen. Bitte melden Sie sich erneut an.',
    token_invalid_or_expired: 'Token ist ungültig oder abgelaufen',
    refresh_token_missing: 'Refresh-Token fehlt',
    refresh_token_invalid: 'Refresh-Token ist ungültig oder abgelaufen',
    token_refresh_success: 'Token wurde erfolgreich aktualisiert',
    captcha_failed: 'Captcha-Überprüfung fehlgeschlagen',
    email_already_used: 'Diese E-Mail-Adresse wird bereits verwendet',
    register_error_generic: 'Beim Erstellen des Kontos ist ein Fehler aufgetreten',
    register_error_retry: 'Beim Erstellen Ihres Kontos ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut',
    register_success_verify_email: 'Registrierung erfolgreich. Bitte überprüfen Sie Ihre E-Mail',
    confirm_register_error: 'Fehler bei der Registrierungsbestätigung',
    store_id_invalid: 'Shop-Kennung ist ungültig',
    store_id_mismatch: 'Shop-Kennung stimmt nicht überein',
    store_not_found: 'Shop nicht gefunden',
    store_setting_not_found: 'Einstellung nicht gefunden',
    store_privacy_policy_not_found: 'Datenschutzrichtlinie nicht gefunden',
    store_condition_use_not_found: 'Nutzungsbedingungen nicht gefunden',
    store_theme_not_found: 'Theme nicht gefunden',
    store_no_categories: 'Diesem Shop sind keine Kategorien zugeordnet',
    store_no_category_ids: 'Keine Kategorien mit diesen Kennungen gefunden',
    store_load_error: 'Beim Laden der Shop-Daten ist ein Fehler aufgetreten',
    user_not_found: 'Benutzer nicht gefunden',
    customer_id_invalid: 'Benutzer-Kennung ist ungültig',
    customer_id_missing: 'Benutzer-Kennung fehlt',
    customer_fetch_error: 'Beim Abrufen der Benutzerinformationen ist ein Fehler aufgetreten',
    customer_error_generic: 'Benutzerfehler',
    customer_data_missing: 'Kundendaten fehlen',
    customer_data_invalid: 'Kundendaten sind ungültig',
    email_not_verified: 'Der Benutzer hat seine E-Mail nicht bestätigt',
    email_not_verified_cannot_modify_password: 'Bitte bestätigen Sie Ihre E-Mail, bevor Sie Änderungen vornehmen',
    email_or_password_invalid: 'E-Mail oder Passwort ist ungültig.',
    email_or_store_invalid: 'E-Mail oder Shop ist ungültig',
    email_already_confirmed: 'Sie haben Ihre E-Mail bereits bestätigt',
    email_confirmed_success: 'Ihre E-Mail ist bestätigt, Sie werden weitergeleitet',
    password_incorrect: 'Passwort ist nicht korrekt',
    password_invalid: 'Passwort ist ungültig.',
    old_password_invalid: 'Das alte Passwort ist ungültig',
    password_reset_link_active: 'Ein Link zum Zurücksetzen des Passworts ist aktiv',
    reset_link_already_active: 'Ein Reset-Link ist bereits aktiv. Bitte überprüfen Sie Ihre E-Mail',
    reset_token_expired: 'Die Änderung ist abgelaufen, bitte stellen Sie eine neue Anfrage',
    reset_token_expired_retry: 'Token ist ungültig oder abgelaufen, bitte stellen Sie eine neue Anfrage',
    forget_password_email_sent: 'Sie erhalten eine E-Mail, um Ihr Passwort zu ändern',
    forget_password_error: 'Fehler bei der Verarbeitung der Passwort-Vergessen-Anfrage',
    password_reset_success: 'Ihr Passwort wurde erfolgreich geändert!',
    password_reset_error: 'Fehler beim Aktualisieren des vergessenen Passworts',
    user_cannot_change_password: 'Der Benutzer kann sein Passwort nicht ändern!',
    user_cannot_modify_password: 'Der Benutzer kann sein Passwort nicht ändern',
    verify_modify_success: 'Der Benutzer kann sein Passwort ändern',
    update_success: 'Informationen wurden erfolgreich aktualisiert.',
    update_error: 'Fehler beim Aktualisieren der Daten!',
    update_password_success: 'Passwort erfolgreich aktualisiert.',
    update_password_success_redirect: 'Ihr Passwort wurde geändert, Sie werden weitergeleitet',
    update_password_error: 'Fehler beim Aktualisieren des Passworts',
    user_pending_deletion: 'Der Benutzer hat die Kontolöschung beantragt',
    account_pending_deletion_service_denied: 'Ihr Konto hat eine aktive Löschanfrage',
    user_no_deletion_request: 'Der Benutzer hat keine Kontolöschung beantragt',
    user_archived: 'Der Benutzer wurde archiviert',
    user_deleted_success: 'Ihr Konto wurde erfolgreich gelöscht',
    delete_user_error: 'Beim Löschen Ihres Kontos ist ein Fehler aufgetreten',
    delete_request_success: 'Ihre Kontolöschungsanfrage wurde registriert',
    delete_request_error: 'Bei der Kontolöschungsanfrage ist ein Fehler aufgetreten.',
    cancel_delete_success: 'Ihre Kontolöschungsanfrage wurde erfolgreich storniert.',
    cancel_delete_success_with_warning: 'Die Kontolöschungsanfrage wurde erfolgreich storniert. Für mehr Sicherheit aktualisieren Sie bitte Ihr Passwort.',
    account_verification_error: 'Bei der Kontoüberprüfung ist ein Fehler aufgetreten.',
    login_success: 'Anmeldung erfolgreich, Sie werden weitergeleitet',
    login_success_old_password: 'Anmeldung erfolgreich, Sie werden weitergeleitet. Für mehr Sicherheit aktualisieren Sie bitte Ihr Passwort',
    login_error_generic: 'Bei Ihrem Anmeldeversuch ist ein Fehler aufgetreten',
    disconnect_success: 'Erfolgreich abgemeldet',
    disconnect_error: 'Beim Abmelden ist ein Fehler aufgetreten',
    me_success: 'Informationen erfolgreich abgerufen',
    fetch_me_error: 'Beim Abrufen Ihrer Informationen ist ein Fehler aufgetreten.',
    otp_request_success: 'Code-Anfrage ist gültig',
    otp_request_error: 'Bei der Code-Anfrage ist ein Fehler aufgetreten.',
    otp_valid: 'Gültiger Code, Sie können Ihre Informationen ändern',
    otp_invalid: 'Ungültiger Code, bitte überprüfen Sie Ihren Code',
    otp_already_used: 'Sie haben Ihren Zugangscode bereits verwendet',
    otp_verification_error: 'Bei der Code-Überprüfung ist ein Fehler aufgetreten.',
    otp_verification_success: 'Der Zugangscode wurde erfolgreich überprüft.',
    otp_send_success: 'Der Zugangscode wurde per E-Mail gesendet.',
    otp_send_error: 'Beim Senden des Zugangscodes ist ein Fehler aufgetreten',
    city_or_postal_invalid: 'Die Stadt oder Postleitzahl ist ungültig',
    address_duplicate: 'Eine identische Adresse existiert bereits für diese Stadt.',
    address_not_found: 'Diese Adresse existiert nicht',
    address_not_found_for_customer: 'Für diesen Kunden wurde keine Adresse gefunden.',
    address_id_missing_or_invalid: 'Die Adress-Kennung ist ungültig oder fehlt',
    address_limit_reached: 'Sie haben die maximale Anzahl der zulässigen Adressen erreicht.',
    address_added_success: 'Ihre Adresse wurde erfolgreich gespeichert.',
    address_added_success_default: 'Ihre Adresse wurde als Standard gespeichert.',
    address_added_error: 'Beim Hinzufügen der Adresse ist ein Fehler aufgetreten',
    address_update_success: 'Ihre Adresse wurde aktualisiert',
    address_update_success_default: 'Ihre Adresse wurde aktualisiert und als Standard gespeichert',
    address_update_error: 'Beim Aktualisieren der Adresse ist ein Fehler aufgetreten',
    address_delete_success: 'Die Adresse wurde gelöscht',
    address_delete_error: 'Fehler beim Löschen der Adresse',
    address_fetch_error: 'Fehler beim Abrufen der Adressdaten!',
    order_too_many_requests: 'Zu viele Anfragen. Bitte warten Sie, bevor Sie es erneut versuchen.',
    order_price_mismatch: 'Der angegebene Preis stimmt nicht mit den Daten überein.',
    order_created_success: 'Bestellung erstellt',
    order_creation_error: 'Fehler beim Erstellen der Bestellung',
    order_cancelled_success: 'Bestellung geändert',
    order_cancel_error: 'Fehler',
    order_id_missing: 'Bestell-ID fehlt',
    order_id_invalid: 'Bestell-ID ist ungültig',
    orders_not_found: 'Keine Bestellungen gefunden',
    orders_fetch_success: 'Bestellungen erfolgreich abgerufen',
    order_stripe_failed: 'Erstellung der Zahlungssitzung fehlgeschlagen. Bitte wenden Sie sich an das Restaurant.',
    pay: 'Bezahlen',
    amountUnavailable: 'Betrag nicht verfügbar',

    // Legal pages (CGU / Privacy Policy)
    cguTitle: 'Allgemeine Nutzungsbedingungen',
    privacyTitle: 'Datenschutzrichtlinie',
    lastUpdated: 'Letzte Aktualisierung:',
    cguIntro: 'Die vorliegenden Nutzungsbedingungen regeln die Nutzung der Website https://{hostname} und ihrer Dienste. Durch den Zugriff auf diese Website und deren Nutzung erklären Sie sich mit diesen Bedingungen einverstanden. Wenn Sie diese Bedingungen nicht akzeptieren, nutzen Sie unsere Website bitte nicht.',
    privacyWelcomeBefore: 'Willkommen bei ',
    privacyWelcomeAfter: ', wir bieten einen Online-Bestellservice an.',
    privacyIntro: 'Diese Datenschutzrichtlinie erläutert, wie wir Ihre personenbezogenen Daten erheben, verwenden und schützen.',
    contactLabel: 'Kontakt:',

    // Page titles (browser tab)
    productCatalog: 'Produktkatalog',
    productDetails: 'Produkt',
    registerTitle: 'Registrierung',
    confirmRegistration: 'Registrierungsbestätigung',
    cartOrderTitle: 'Warenkorb - Bestellung',
    dashboardEditInfo: 'Dashboard - Persönliche Informationen bearbeiten',
    dashboardEditPassword: 'Dashboard - Passwort ändern',
    dashboardAddresses: 'Dashboard - Adressverwaltung',
    dashboardOrders: 'Dashboard - Bestellverlauf',

    // Language names
    languages: {
        tr: 'Türkçe',
        fr: 'Français',
        en: 'English',
        de: 'Deutsch'
    }
}
